import { render, staticRenderFns } from "./MyUserCard.vue?vue&type=template&id=38e2eb53&scoped=true&"
import script from "./MyUserCard.vue?vue&type=script&lang=js&"
export * from "./MyUserCard.vue?vue&type=script&lang=js&"
import style0 from "./MyUserCard.vue?vue&type=style&index=0&id=38e2eb53&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38e2eb53",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardActions } from 'vuetify/lib/components/VCard';
import { VExpandTransition } from 'vuetify/lib/components/transitions';
import { VListItem } from 'vuetify/lib/components/VList';
import { VListItemContent } from 'vuetify/lib/components/VList';
import { VListItemSubtitle } from 'vuetify/lib/components/VList';
import { VListItemTitle } from 'vuetify/lib/components/VList';
import { VSpacer } from 'vuetify/lib/components/VGrid';
installComponents(component, {VBtn,VCard,VCardActions,VExpandTransition,VListItem,VListItemContent,VListItemSubtitle,VListItemTitle,VSpacer})
